import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

import { MapComponent } from '@shared/map/map.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { MapInputSearchComponent } from '@shared/map/components/map-input-search/map-input-search.component';
import { HotelFilterBarModule } from '@shared/magic-filter-bar/hotel-filter-bar/hotel-filter-bar.module';
import { MarkerDsComponent } from '@design-system/components/molecules/marker/marker.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { InputSearchDsComponent } from '@design-system/components/molecules/input-search/input-search.component';

@NgModule({
  declarations: [
    MapComponent,
    MapInputSearchComponent
  ],
  exports: [
    MapComponent
  ],
  imports: [
    CommonModule,
    GoogleMapsModule,
    FormsModule,
    GlobalPipesModule,
    TranslocoModule,
    HotelFilterBarModule,
    MarkerDsComponent,
    IconDsComponent,
    InputSearchDsComponent,
  ]
})
export class MapModule { }
